import React, { Component } from 'react';

class Sidebar extends Component {
    render() {

        let data = [
            {sidebarListLink: "early-intervention",sidebarListIcon: "fa fa-child",sidebarListText: "Early Intervention & Child Development" },
            {sidebarListLink: "play-language-therapy",sidebarListIcon: "fa fa-comments",sidebarListText: "Play & Language Therapy"},
            {sidebarListLink: "social-communication",sidebarListIcon: "fa fa-users",sidebarListText: "Social Communication & Behaviour Modification"},
            {sidebarListLink: "speech-therapy",sidebarListIcon: "fa fa-microphone",sidebarListText: "Speech Therapy"},
            {sidebarListLink: "special-education",sidebarListIcon: "fa fa-graduation-cap",sidebarListText: "Special Education"},
            {sidebarListLink: "learning-support",sidebarListIcon: "fa fa-book",sidebarListText: "Learning Support"},
            {sidebarListLink: "occupational-therapy",sidebarListIcon: "fa fa-hand-paper-o",sidebarListText: "Occupational Therapy"},
            {sidebarListLink: "parent-counselling",sidebarListIcon: "fa fa-user-circle",sidebarListText: "Parent Counselling and Guidance"},
            {sidebarListLink: "holistic-child-development",sidebarListIcon: "fa fa-heart",sidebarListText: "Holistic Child Development"},
            {sidebarListLink: "sports-program-development",sidebarListIcon: "fa fa-futbol-o",sidebarListText: "Sports Programs for Development"}
        ];

        let Datalist = data.map((val, i) => {
            return (
                <li key={i}><a href={val.sidebarListLink}><i className={val.sidebarListIcon} />{val.sidebarListText}</a></li>
            )
        })

        return (
            <div>
                <div className="sidebar-wrapper">
                    <div className="sidebar">
                        <h3 className="sidebar-title">Services</h3>
                        <ul className="sidebar-list">
                            {Datalist}
                        </ul>
                    </div>

                </div>
            </div>
        )
    }
}

export default Sidebar;